import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">漫画全集索引</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            飞飞漫画网漫画大全分类索引，按主题快速找到你想看的漫画全集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden aspect-[5/3]">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 text-[10px] font-semibold bg-background-50/90 text-foreground-800 rounded whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}